module.exports = __webpack_public_path__ + "static/media/shop_back.87553b54.svg";